<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaAdmHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaAdmHotel from "../Components/Listagens/ListaAdmHotel.vue";
export default {
  name: "ListHotel",
  components: {
    ListaAdmHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
